// exp_PORTFOLIO-61587_file
import { FC } from 'react';

import { Banner, Text, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    title: 'VacancyOfTheDayPage.info.title',
    description: 'VacancyOfTheDayPage.info.description',
};

export const MobileBanner: FC = () => {
    const { isMobile } = useBreakpoint();
    const trls = useTrls();

    if (!isMobile) {
        return null;
    }

    return (
        <Banner
            stretched
            showClose={false}
            style="secondary"
            title={<Text typography="title-5-semibold">{trls(TrlKeys.title)}</Text>}
            content={<Text>{trls(TrlKeys.description)}</Text>}
            data-qa="vacancy-of-the-day-mobile-banner"
        />
    );
};
